export default __webpack_public_path__ + "static/hambletonian10-18b5377223ce9a5cfdf585af0738a806.png";